import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页', icon: 'ri-home-4-line' },
  { path: '/categories', label: '分类', icon: 'ri-grid-line' },
  { path: '/articles', label: '文章', icon: 'ri-article-line' },
  { path: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2 whitespace-nowrap">
            <span className="text-2xl font-heading font-bold text-primary-500">jiuyou</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-500'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-background-50 hover:text-primary-300'
                }`}
              >
                {link.label}
                {location.pathname === link.path && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-5 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center space-x-4">
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap px-5 py-2 rounded-full transition-all duration-200 ${
                isScrolled || !isHome
                  ? 'border border-foreground-300 text-foreground-700 hover:border-primary-400 hover:text-primary-500'
                  : 'border border-background-300 text-background-50 hover:border-background-50 hover:bg-background-50/10'
              }`}
            >
              联系我们
            </Link>
            <Link
              to="/categories"
              className="text-sm font-medium whitespace-nowrap px-5 py-2 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200"
            >
              立即体验
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'} ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${link.icon} text-lg`} />
                <span>{link.label}</span>
              </Link>
            ))}
            <div className="pt-3 border-t border-background-200">
              <Link
                to="/categories"
                className="block w-full text-center text-sm font-medium px-5 py-3 rounded-full bg-primary-500 text-background-50"
              >
                立即体验
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}